export default __webpack_public_path__ + "static/media/Events.e7592c36.svg";